import { useState, useEffect } from 'react';
import { useTranslation } from 'react-i18next';

import { socket } from 'api';
import { OutlineButton, CustomSelect } from 'libs/ui';
import { Content, Title, Block } from './option-receipt.styled';

export const OptionReceipt = ({ sendControlMsg, templateId, className }) => {
  const { t } = useTranslation();
  const [items, setItems] = useState(null);
  const [value, setValue] = useState(templateId ?? '');
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    const updateItems = (data) => {
      setItems(data.items);
    };

    const setLoadingOff = () => {
      // console.log('🚀 ~ setLoadingOff ~ msg:', msg);
      setTimeout(() => setLoading(false), 250);
    };

    const updateSocketState = () => {
      sendControlMsg('get_state');
    };

    socket.on('racks.set_receipt_template', updateSocketState);
    socket.on('get_state', setLoadingOff);
    socket.on('receipt_template.list', updateItems);
    socket.call('receipt_template.list', { filter_params: {}, sort_params: [], paging_params: { limit: 100, offset: 0 } });

    return () => {
      socket.off('racks.set_receipt_template', updateSocketState);
      socket.off('get_state', setLoadingOff);
      socket.off('receipt_template.list', updateItems);
    };
  }, []);

  /**
   * change enabled
   * @param {*} event
   */
  const setTemplate = () => {
    setLoading(true);
    sendControlMsg('racks.set_receipt_template', { receipt_template_id: value ? parseInt(value) : null });
  };

  /**
   * change value
   * @param {*} event
   * @returns
   */
  const onChange = (val) => {
    setValue(val);
  };

  if (!items) {
    return null;
  }

  const options = [{ value: '', name: t('forms.Системный шаблон') }, ...items.map((el) => ({ value: el.receipt_template_id, name: el.name }))];
  const cl = `${className} ${loading ? 'loading' : ''}`;

  return (
    <Content className={cl}>
      <Title>{t('forms.Шаблон билета')}</Title>
      <Block>
        <CustomSelect items={options} value={value} onChange={onChange} style={{ minWidth: '200px', marginRight: '1rem' }} />
        <OutlineButton className="field" onClick={setTemplate}>
          {t('buttons.Установить')}
        </OutlineButton>
      </Block>
    </Content>
  );
};
